import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment, { Moment } from "moment";
import { Subscription } from 'rxjs';
import { FirestoreService } from 'src/app/services/firestore.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilService } from 'src/app/services/util.service';
import * as _ from 'lodash';
import { environment } from './../../../../environments/environment';
import { th } from 'date-fns/locale';

@Component({
  selector: 'app-monitor',
  templateUrl: './monitor.component.html',
  styleUrls: ['./monitor.component.scss']
})
export class MonitorComponent implements OnInit {
  [x: string]: any;
  chartData: any = [];
  minDate: Moment;
  maxDate: Moment;

  InitialDates = {
    startDate: moment().subtract(1,'day').startOf('day').format("MM/DD/YYYY HH:mm:ss"),
    endDate: moment().format("MM/DD/YYYY HH:mm:ss")
  }
  selectedDateRanges = {
    start: moment().subtract(1,'day').startOf('day'),
    end: moment().format("MM/DD/YYYY HH:mm:ss"),
  }
  assetData: any = [];
  selectedAssetData: any = {};
  filter: any = {
    asset: {
      data: [],
      selected: []
    },
    raw: {
      data: [],
      selected: ""
    },
    aggregation: {
      //data: [{time:"Live",collection:"localHistory"},{time:"10 Minutes",collection:"Aggregate10MinuiteData"},{time:"60 Minutes",collection:'Aggregate60MinuiteData'},{time:"1 Day",collection:"Aggregate1440MinuiteData"}],
      //{ time: "Live", collection: "localHistory" },
      data: [
     // { time: "History", collection: "HistoryData" },
      { time: "15 Minutes", collection: "15minutes", disableOption:false },
      { time: "60 Minutes", collection: "60minutes", disableOption:false },
      { time: "1 Day", collection: "1440minutes", disableOption:false }],
      selected: { time: "15 Minutes", collection: "15minutes", disableOption:false },
    }
  };
  zoneList = [
    {
      name: "Loading",
      zoneId: "Loading",
      tagListName: "loadingTags",
      assetListName: "loadingAssets",
    },
    {
      name: "Sealer Line",
      zoneId: "Sealer Line",
      tagListName: "sealerLineTags",
      assetListName: "sealerLineAssets",
    },
    {
      name: "Top Coat",
      zoneId: "Top Coat",
      tagListName: "topcoatTags",
      assetListName: "topcoatAssets",
    },
  ];
  selectedZone = this.zoneList[0];
  uniqueCode: string = "";
  subscription_tagData: any;
  historyResponse: any = [];
  graphData: any = { datapoints: {}, tagdetails: {} };
  historySubcription: any;
  startDate: any;
  endDate: any;
  liveDataSubscription: Subscription | undefined;
  liveData: any;
  liveTagData: any;
  showTags: boolean = false;
  showAssests: boolean = false;
  constructor(private fs: FirestoreService, private router: Router, private activeRoute: ActivatedRoute,
    private subject: SubjectService, private util: UtilService) {
    this.activeRoute.params.subscribe(param => {
      this.uniqueCode = param.code;
    });
    let assetParams = {
      category: "CURRENTDATA"
    }
    this.fs.getData(assetParams).subscribe((response: any) => {
  
      this.filter.asset.data =this.util.getAssets(response.data);
      //this.filter.asset.data = response.data;
      this.filter.asset.selected.push(this.filter.asset.data[0]);
      this.loadTags();
    });
  }

  ngOnInit(): void {
    this.getData()
    const currentYear = moment().year();
 this.minDate = moment([currentYear - 1, 0, 1]);
 this.maxDate = moment([currentYear + 1, 11, 31]);
  }
  getData(){
    this.util.setLoaderValue(true)
    this.filter.asset.selected.forEach((val:any)=>{
      let params = {
        asset:val.asset,
        startDate:moment(this.selectedDateRanges.start).toDate(),
        endDate:moment(this.selectedDateRanges.end).toDate(),
        aggregationType:this.filter.aggregation.selected.collection
      }
      this.fs.getAggregationData(params).subscribe(res =>{
      this.util.setLoaderValue(false)
        let collection = []
        res.forEach(r=>{
          collection.push(r.data())
        })
        this.historyResponse.push(...collection);
            if (this.historyResponse.length>=0) {
              this.prepareTagData();
            }
       },(err) =>{
      this.util.setLoaderValue(false)
       })
    })
   
  }
  loadTags() {
    this.filter.raw.data=[]
    this.filter.asset.selected.forEach((val:any)=>{
      let filter = [
        {
          key: "asset",
          symbol: "==",
          value: val.asset
        },
      ];
      let tagsParams = {
        category: "CURRENTDATA",
        conditions: filter
      }
    this.showTags =false;
    this.showAssests =false;
    this.subscription_tagData = this.fs.getData(tagsParams).subscribe((response: any) => {
      if (response.status == "success") {
        this.filter.raw.data.push( ...response.data[0].tags);
        this.showTags =true;
        this.showAssests =false;
        this.filter.raw.data.forEach((element: any) => {
          element.component = element.component?.replace(/_/g, " ");
        });
        this.filter.raw.selected = [this.filter.raw.data[0]];
      }
    });
  })
  this.getData();
  }
  filterChange(event: any, type: string) {
    this.startDate = moment(event.startDate.$d).format("MM/DD/YYYY HH:mm:ss");
    this.endDate = moment(event.endDate.$d).format("MM/DD/YYYY HH:mm:ss");
    this.selectedDateRanges.start = this.startDate;
    this.selectedDateRanges.end = this.endDate;
    let start = moment(this.startDate);
    let end = moment(this.endDate);
    let diffmin = end.diff(start, 'minute');
    if (this.filter.aggregation.selected.collection== 'HistoryData' && diffmin > 60) {
      this.util.showSnakbarMessage("warning", "Please select 1hour range for Raw Data!", "end", "top");
    }
    this.getData()
  }

  changeFilter(data: any, type: string) {
    this.filter[type].selected = data;
    if (type == "asset") {
      this.loadTags();
    }else if(type == 'aggregation'){
      this.getData()
    }
  }
  // redirectPage(type: string) {
  //   if (type == "dashboard") {
  //     this.router.navigate(["page/dashboard"]);
  //   }  else if (type == 'monitor') {
  //     this.router.navigate(['page/monitor', this.uniqueCode]);
  //   }
  // }
  redirectPage(page) {
    this.subject.setselectedmenu(0)
    this.router.navigate(["/home/" + page]);
 
  }

  loadLiveTags() {
    let params = {
      category: "CURRENTDATA",
      conditions: [
        {
          key: "asset",
          symbol: "==",
          value: this.filter.asset.selected.asset
        },
        {
          key: "assetcode",
          symbol: "==",
         value: this.filter.asset.selected.assetcode
         //value: false
        }
      ]
    }
    this.liveDataSubscription = this.fs.getData(params).subscribe((response: any) => {
      if (response.status == "success") {
        this.liveData = response.data;
        this.liveData.forEach((element: any) => {
        this.liveTagData = _.unionBy(this.liveTagData, element.tags, "tag");
        });

        let updatedData = Math.max.apply(
          Math,
          this.liveData.map((o) => {
            return o.timestamp._seconds;
          })
        );
        let lastTimestamp = moment(updatedData * 1000);
        let back60mins = lastTimestamp.subtract(1, 'hours');
        let start = back60mins.format("MM/DD/YYYY HH:mm:ss")
        let end = lastTimestamp.format("MM/DD/YYYY HH:mm:ss")
        this.InitialDates = {
          startDate: start,
          endDate: end
        }
        this.loadChartData();
      }
    });
  }


  loadChartData() {
    let start = moment(this.selectedDateRanges.start['_a']);
    let end = moment(this.selectedDateRanges.end['_a']);
    let diffmin = end.diff(start, 'minute');
    if (this.filter.aggregation.selected.collection != 'HistoryData' && diffmin > 60) {
     this.util.showSnakbarMessage("warning", "Please select 1hour range for Raw Data!", "end", "top");
    } else {
      this.historyResponse = [];
      let filter = [
        {
          key: "timestamp",
          symbol: ">=",
          value: moment(this.selectedDateRanges.start).toDate()
        },
        {
          key: "timestamp",
          symbol: "<=",
          value: moment(this.selectedDateRanges.end).toDate()
        }
      ];
      let historyParams: any = {
        asset: this.filter.asset.selected.asset,
        assetcode: this.filter.asset.selected.assetcode,
        assettype: this.filter.asset.selected.assettype,
        filterTags: this.filter.raw.selected,
        startDate: moment(this.selectedDateRanges.start).format("YYYY/MM/DD HH:mm:ss"),
        endDate: moment(this.selectedDateRanges.end).format("YYYY/MM/DD HH:mm:ss"),
        conditions: filter,
        category: "HISTORY",
        defaultAssetcode: this.selectedAssetData.originalAssetcode,
      };
      if(this.filter.aggregation.selected.collection != 'HistoryData'){
        historyParams['aggregateFrame'] = this.filter.aggregation.selected.collection
      }
      if (this.filter.aggregation.selected && Object.keys(this.filter.aggregation.selected).length > 0) {
        let collectionName = "History";
        historyParams.collectionName = `${collectionName}/${this.filter.asset.selected.assettype}/${this.filter.asset.selected.id}`;
        historyParams.aggregation = this.filter.aggregation.selected.collection;
      }
      this.util.setLoaderValue(true);
      this.fs.getData(historyParams).subscribe((response: any) => {
        this.util.setLoaderValue(false);
        if (response.data.length > 0 && response.message == "Success") {
          this.graphData = { datapoints: {}, tagdetails: {} };
          this.historyResponse = response.data;
          if (response.data.length > 0) {
            this.prepareTagData();
          }

        } else if(response.data.length == 0 && response.message == "Success")  {
          this.util.showSnakbarMessage("info", "No data found for selected date time range", "end", "top");
        }
      });
    }

  }
  prepareTagData() {
    return new Promise((resolve, reject) => {
      let xaxis: any = [];
      this.graphData = {datapoints:{},tagdetails:{}}
      this.historyResponse.forEach((d, index) => {
        d.tags.forEach((historyTagData) => {
          this.filter.raw.selected.forEach((configtagData: any) => {
            if (configtagData.tag == historyTagData.tag || configtagData.tag == historyTagData.component) {
              let date = moment(d.timestamp.seconds * 1000).format("DD/MMM/YYYY, HH:mm:ss");
              if (date) {
                if (xaxis.indexOf(date) == -1) {
                  xaxis.push(date);
                }
                if (!this.graphData["datapoints"][historyTagData.tag]) {
                  this.graphData["datapoints"][historyTagData.tag] = [];
                }
                if (!this.graphData["tagdetails"][historyTagData.tag]) {
                  this.graphData["tagdetails"][historyTagData.tag] = {};
                }

                let xValue = moment(d.timestamp.seconds * 1000).valueOf();
                let chartTagDataFilter = this.graphData["datapoints"][historyTagData.tag].filter((chartTagData) => {
                  return chartTagData.x == xValue;
                })
                if (chartTagDataFilter.length == 0) {
                  this.graphData["datapoints"][historyTagData.tag].push(
                    {
                      x: moment(d.timestamp.seconds * 1000).valueOf(),
                      y: typeof historyTagData.value == "string" ? parseFloat(historyTagData.value) : historyTagData.value || 0,
                    }
                  );
                  this.graphData.tagdetails[historyTagData.tag] = configtagData;
                }

              }

            }
          });
        });

      });
      resolve({ gd: this.graphData, xaxis: xaxis })
    }).then((data: any) => {
      this.chartData = [];
      setTimeout(() => {
        this.chartData.push(
          this.compareTagsForMonitor({
            data: data.gd.datapoints,
            tagdetails: data.gd.tagdetails,
            xaxis: data.xaxis,
          })[0]
        );
      }, 100)

    });
  }


  compareTagsForMonitor(Data) {
    const colors = ["#427bff", "#FFC300", "#00c120", "#ec8d22", "#5abc71"]
    const final_array: any = [];
    let y_current: any = [];
    let yaxis: any = [];
    let self = this;
    let i = 0;
    for (let key in Data.data) {
      let obj;
      let y: any;
      y = {
        title: {
          enabled: false,
          text: `${Data.tagdetails[key].unit}`,
          style: {
            color: colors[i]
          },
          
        },
        opposite:false,
        labels: {
          enabled: false,
          style: {
            color: colors[i]
          }
        },
      }
      yaxis.push(y);
      obj = {
        marker: {
          enabled: false,
        },
        name: `${Data.tagdetails[key].component}`,
        color: colors[i],
        yAxis: i,
        tooltip: {
          xDateFormat: '%d-%m-%y, %H:%M:%S',
          valueDecimals: 2,
          valueSuffix: ` ${Data.tagdetails[key].unit}`,
        },
        type: "line",
        data: (function () {
          let data: any = [],
            time = new Date().getTime(),
            x,
            y,
            i = -Data.data[key].length;
          for (i; i < 0; i += 1) {
            y = Data.data[key][i + Data.data[key].length].y;
            x = Data.xaxis[i + Data.xaxis.length];
            let time2 = new Date(x).getTime();
            data.push([time2, y]);
          }
          return data;
        })(),
      };
      y_current.push(obj);
      i++
    }
    yaxis[yaxis.length - 1] = { ...yaxis[yaxis.length - 1], ...{ opposite: true } }
    final_array.push({
      xaxis: Data.xaxis,
      yaxis: yaxis,
      series: y_current,
      label_y: "Values",
      threshold: [
        {
          "color ": "transparent ",
          "width ": 1,
          "value ": 99999,
          "zIndex ": 5,
          "label ": {
            "align ": "center ",
            "labels":{
              "enabled":false
                },
            "dataLabels":{
              "enabled": false
            },
            "style ": {
              "fontSize ": "10px ",
              "color ": "transparent "
            },
            "text ": "Upper Threshold 99999 - L20 ",
            "textAlign ": "center ",
            "useHTML ": false,
            "verticalAlign ": "top "
          }
        }
      ],
      accessibility: {
        announceNewData: {
          enabled: true,
          minAnnounceInterval: 15000,
          announcementFormatter: function (allSeries, newSeries, newPoint) {
            if (newPoint) {
              return "New point added. Value: " + newPoint.y;
            }
            return false;
          },
        },
      },
      events: {
        load: function (series) {
          self.subject.monitordata.subscribe((value) => {
            if (series != undefined) {
              series.target.series.forEach((se, index) => {
                if (se.name && value[se.name]) {
                  se.addPoint([value[se.name].x, value[se.name].y], true, true);
                }
              });
            }
          });
        }
      },

      mr: 25,
      mt: 20,
      ml: 80,
      mb: 70,
      min_y: 0,
      unit: "",
      format: true,
    });
    return final_array;
  }


  socketconnection() {
    this.subject.setupSocketConnection();
    this.historySubcription = this.subject.getHistoryUpdateListener().subscribe((historyUpdate: any) => {
      if (historyUpdate && historyUpdate.messageid) {
        this.subject.setLastUpdatedDate(historyUpdate.messageid);
      }
      if (this.historyResponse && this.historyResponse.length > 0) {
        if (historyUpdate.asset == this.filter.asset.selected.asset && historyUpdate.assetcode == this.filter.asset.selected.assetcode) {
          this.historyResponse.shift();
          this.historyResponse.push(historyUpdate);
          this.updatechartForAsset(historyUpdate);
        }
      }
    });
  }

  updatechartForAsset(data) {
    let x;

    x = data.messageid * 1000;

    let obj = {};
    this.filter.raw.selected.forEach((configtagData: any) => {
      let tag = configtagData.tag;
      if (tag) {
        let filterTagData = data.tags.filter((tagdata) => {
          return tagdata.tag == tag;
        });
        if (filterTagData.length > 0) {
          obj[filterTagData[0].component] = {
            x: x,
            y: typeof filterTagData[0].value == "string" ? parseFloat(filterTagData[0].value) : filterTagData[0].value,
          }
        }
      }

    });
    if (Object.keys(obj).length > 0) {
      this.subject.monitorGraphDataUpdate(obj);
    }

  }
  changezone(e) {
    this.subsink.unsubscribe();
    clearInterval(this.time);
    this.selectedZone = e;
    this.selectedZoneData = JSON.parse(
      JSON.stringify(this[this.selectedZone.tagListName])
    );
    this.loadTagData();
  }

  clearTags() {
    this.filter.raw.selected = [];
  }

}
